import { render, staticRenderFns } from "./AppsSelector.vue?vue&type=template&id=bda0b758"
import script from "./AppsSelector.vue?vue&type=script&lang=js"
export * from "./AppsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports